export const ROOT_PATH = '/';

export function itemIsActive(currentPath, activeFor) {
  if (ROOT_PATH === currentPath && activeFor.includes(ROOT_PATH)) {
    return true;
  }

  return activeFor.some((path) => ROOT_PATH !== path && currentPath.startsWith(path));
}